import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getAuth, applyActionCode } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from '../firebaseConfig';
import './StripePages.css';

function EmailVerifyPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const verifyEmail = async () => {
      const oobCode = searchParams.get('oobCode');
      
      if (!oobCode) {
        setStatus('error');
        setMessage('Invalid verification link');
        return;
      }

      try {
        const app = initializeApp(firebaseConfig);
        const auth = getAuth(app);
        
        await applyActionCode(auth, oobCode);
        
        setStatus('success');
        setMessage('Email verified successfully!');
      } catch (error) {
        console.error('Verification error:', error);
        setStatus('error');
        setMessage(error.message || 'Verification failed');
      }
    };
    
    verifyEmail();
  }, [searchParams]);

  const handleReturnToApp = () => {
    window.location.href = 'fodyfee://email-verified';
    
    setTimeout(() => {
      window.location.href = 'https://app.fodyfee.com';
    }, 1500);
  };

  return (
    <div className="stripe-page-container">
      <div className={`stripe-card ${status}`}>
        <div className="stripe-icon">
          {status === 'success' ? '✓' : status === 'error' ? '✗' : '↻'}
        </div>
        <h1>{status === 'success' ? 'Verified!' : status === 'error' ? 'Error' : 'Verifying...'}</h1>
        <p>{message}</p>
        
        {status === 'success' && (
          <button onClick={handleReturnToApp} className="primary-button">
            Return to FodyFee App
          </button>
        )}
        
        {status === 'error' && (
          <button 
            className="primary-button"
            onClick={() => window.location.href = 'https://app.fodyfee.com/account'}
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}

export default EmailVerifyPage;